import { get } from "lodash";
import moment from "moment";
import { DATE_TIME_FORMAT } from "utils/constants";

function Detail({ event = {}, EVENT_TYPES, translation }) {
  return (
    <div className="event-detail-content">
      <div className="event-detail-content__item">
        <span>{translation.EVENT_TITLE}</span>
        <strong>{event.title || translation.NO_TITLE}</strong>
      </div>
      <div className="event-detail-content__item">
        <span>{translation.DATES}</span>
        <strong>
          {moment(event.start).format(DATE_TIME_FORMAT)} -
          {event.end
            ? moment(event.end).format(DATE_TIME_FORMAT)
            : moment(event.start).format(DATE_TIME_FORMAT)}
        </strong>
      </div>
      <div className="event-detail-content__item">
        <span>{translation.REMINDER_TYPE}</span>
        <strong>{EVENT_TYPES[get(event, "extendedProps.meta.type")]}</strong>
      </div>
      <div className="event-detail-content__item">
        <span>{translation.RECIPIENT}</span>
        <strong>
          {get(event, "extendedProps.meta.user.firstname")}{" "}
          {get(event, "extendedProps.meta.user.lastname")}
        </strong>
      </div>
    </div>
  );
}

export default Detail;
